import { Key, ReactNode } from 'react'
import { getShipmentCount } from '@Orders/OrderDetailsPage/Status/logic'
import { shipmentIdsMapType } from '@Orders/OrderDetailsPage/logic'
import { salesOrder_salesOrder_shipments_items as SalesOrderShipmentsItemType } from '@Orders/OrderDetailsPage//Queries/__generated__/salesOrder'
import { salesOrderLines_salesOrderLines_items_shipmentAndInspection as ShipmentAndInspectionType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrderLines'

import Box from '~/core/Box'
import Link from '~/core/Link'
import { PLACEMENT_ORDERED_ITEMS } from '../logic'
import Tooltip from '~/core/Tooltip'

import { ToggleModalForPartViewerFuncType, useGetShipmentsList } from './logic'

type ShipmentsLineItemsPropsType = {
    shipmentStatus: ReactNode
    shipments: (ShipmentAndInspectionType | null)[]
    shipmentsData?: SalesOrderShipmentsItemType[]
    shipmentIdsMap: shipmentIdsMapType
    toggleModalForPartViewer: ToggleModalForPartViewerFuncType
}

interface CustomizedShipmentAndInspectionType
    extends ShipmentAndInspectionType {
    trackingUrl: string
}

const DISABLE_TOOLTIP_MSG =
    'Once a shipping label has been created you will be able to access tracking via this link. '

const ShipmentsLineItems = (props: ShipmentsLineItemsPropsType) => {
    const {
        toggleModalForPartViewer,
        shipmentStatus,
        shipments,
        shipmentsData,
        shipmentIdsMap,
    } = props

    const handleTrackingLinkClick = ({
        evt,
        shipment,
    }: {
        evt: Event
        shipment?: CustomizedShipmentAndInspectionType | null
    }) => {
        evt.stopPropagation()
        evt.preventDefault()
        toggleModalForPartViewer(false)

        const trackingUrl = shipment?.trackingUrl

        if (trackingUrl) {
            window.open(trackingUrl, '_blank', 'noopener')
        }
    }

    const shipmentsList = useGetShipmentsList({ shipments, shipmentsData })

    return (
        <Box direction="col">
            {shipmentsList.map(shipment => (
                <Box
                    key={shipment?.shipmentId as Key}
                    style={{
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    {shipmentStatus}-
                    <Tooltip
                        title={
                            !shipment.trackingUrl ? DISABLE_TOOLTIP_MSG : null
                        }
                    >
                        {/* have to wrap disabled link with box to let tooltip show up */}
                        <Box
                            marginLeft="4px"
                            onClick={evt =>
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore // need to figure out shipment _typename
                                handleTrackingLinkClick({ evt, shipment })
                            }
                        >
                            <Link
                                data-test-target="track-shipment"
                                disabled={!shipment.trackingUrl} // when there is no trackingCode/trackingUrl
                                name="track-shipment"
                                placement={PLACEMENT_ORDERED_ITEMS}
                                style={{
                                    marginRight: '8px',
                                    whiteSpace: 'nowrap',
                                }}
                                target="_blank"
                            >
                                Track shipment{' '}
                                {getShipmentCount(
                                    shipment?.shipmentId || '',
                                    shipmentIdsMap,
                                )}
                            </Link>
                        </Box>
                    </Tooltip>
                </Box>
            ))}
        </Box>
    )
}

export default ShipmentsLineItems
